import script from "./MainEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./MainEntry.vue?vue&type=script&setup=true&lang=js"

import "./MainEntry.vue?vue&type=style&index=0&id=3c07d722&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c07d722"]])

export default __exports__